import { Brand, DatabaseShape, Model, Supplier } from './types';

export const initialBrands: Brand[] = [
  // Volkswagen Group
  { id: 'vw', name: 'Volkswagen', group: 'Volkswagen Group', logo: 'https://logoeps.com/wp-content/uploads/2013/03/volkswagen-vector-logo.png' },
  { id: 'skoda', name: 'Škoda', group: 'Volkswagen Group', logo: 'https://logos-world.net/wp-content/uploads/2021/03/Skoda-Logo.png' },
  { id: 'seat', name: 'SEAT', group: 'Volkswagen Group', logo: 'https://logos-world.net/wp-content/uploads/2021/03/Seat-Logo.png' },
  { id: 'audi', name: 'Audi', group: 'Volkswagen Group', logo: 'https://logoeps.com/wp-content/uploads/2013/03/audi-vector-logo.png' },
  
  // Renault Group
  { id: 'renault', name: 'Renault', group: 'Renault Group', logo: 'https://logos-world.net/wp-content/uploads/2021/03/Renault-Logo.png' },
  
  // Stellantis Group
  { id: 'fiat', name: 'Fiat', group: 'Stellantis Group', logo: 'https://logos-world.net/wp-content/uploads/2021/03/Fiat-Logo.png' },
  { id: 'peugeot', name: 'Peugeot', group: 'Stellantis Group', logo: 'https://logos-world.net/wp-content/uploads/2021/03/Peugeot-Logo.png' },
  
  // Chinese Brands
  { id: 'geely', name: 'Geely', group: 'Chinese Brands', logo: 'https://logos-world.net/wp-content/uploads/2021/04/Geely-Logo.png' },
  { id: 'jetour', name: 'Jetour', group: 'Chinese Brands', logo: 'https://logos-world.net/wp-content/uploads/2021/04/Jetour-Logo.png' },
];

export const initialSuppliers: Supplier[] = [
  { id: 'supplier-1', name: 'Audi Center Algiers', contact: 'Ahmed Benali', phone: '+213-21-123456', email: 'contact@audialgiers.dz', address: 'Algiers, Algeria' },
  { id: 'supplier-2', name: 'Volkswagen Dealer Oran', contact: 'Fatima Zohra', phone: '+213-41-789012', email: 'info@vw-oran.dz', address: 'Oran, Algeria' },
  { id: 'supplier-3', name: 'Renault Algiers', contact: 'Mohamed Khelil', phone: '+213-21-345678', email: 'sales@renault-algiers.dz', address: 'Algiers, Algeria' },
  { id: 'supplier-4', name: 'Auto Import Center', contact: 'Karima Boudjema', phone: '+213-23-456789', email: 'contact@autoimport.dz', address: 'Constantine, Algeria' },
  { id: 'supplier-5', name: 'Premium Motors', contact: 'Youssef Amrani', phone: '+213-25-567890', email: 'info@premiummotors.dz', address: 'Annaba, Algeria' },
];

export const initialModels: Model[] = [
  // Volkswagen
  { id: 'vw-polo', name: 'Polo', brandId: 'vw' },
  { id: 'vw-golf', name: 'Golf', brandId: 'vw' },
  { id: 'vw-tiguan', name: 'Tiguan', brandId: 'vw' },
  { id: 'vw-passat', name: 'Passat', brandId: 'vw' },
  { id: 'vw-troc', name: 'T-Roc', brandId: 'vw' },
  
  // Škoda
  { id: 'sk-octavia', name: 'Octavia', brandId: 'skoda' },
  { id: 'sk-fabia', name: 'Fabia', brandId: 'skoda' },
  { id: 'sk-rapid', name: 'Rapid', brandId: 'skoda' },
  { id: 'sk-kamiq', name: 'Kamiq', brandId: 'skoda' },
  
  // SEAT
  { id: 'seat-ibiza', name: 'Ibiza', brandId: 'seat' },
  { id: 'seat-arona', name: 'Arona', brandId: 'seat' },
  { id: 'seat-leon', name: 'Leon', brandId: 'seat' },
  
  // Audi
  { id: 'audi-a3', name: 'A3', brandId: 'audi' },
  { id: 'audi-q2', name: 'Q2', brandId: 'audi' },
  
  // Renault
  { id: 'ren-clio4', name: 'Clio 4', brandId: 'renault' },
  { id: 'ren-clio5', name: 'Clio 5', brandId: 'renault' },
  { id: 'ren-symbol', name: 'Symbol', brandId: 'renault' },
  { id: 'ren-megane', name: 'Megane', brandId: 'renault' },
  
  // Fiat
  { id: 'fiat-tipo', name: 'Tipo', brandId: 'fiat' },
  { id: 'fiat-doblo', name: 'Doblò', brandId: 'fiat' },
  { id: 'fiat-500', name: '500', brandId: 'fiat' },
  
  // Peugeot
  { id: 'peu-208', name: '208', brandId: 'peugeot' },
  { id: 'peu-301', name: '301', brandId: 'peugeot' },
  { id: 'peu-2008', name: '2008', brandId: 'peugeot' },
  
  // Geely
  { id: 'geely-coolray', name: 'Coolray', brandId: 'geely' },
  { id: 'geely-gx3pro', name: 'GX3 Pro', brandId: 'geely' },
  
  // Jetour
  { id: 'jetour-emerging', name: 'X70 Plus', brandId: 'jetour' },
];

// Generate random demo cars for rental
const generateDemoCars = () => {
  const carConfigs = [
    { brand: 'audi', model: 'audi-a3', year: 2023, dailyRate: 145, color: 'Black', plate: 'AUD-001' },
    { brand: 'vw', model: 'vw-golf', year: 2022, dailyRate: 120, color: 'White', plate: 'VW-002' },
    { brand: 'vw', model: 'vw-tiguan', year: 2023, dailyRate: 135, color: 'Blue', plate: 'VW-003' },
    { brand: 'renault', model: 'ren-clio5', year: 2022, dailyRate: 100, color: 'Red', plate: 'REN-004' },
    { brand: 'renault', model: 'ren-megane', year: 2023, dailyRate: 110, color: 'Silver', plate: 'REN-005' },
    { brand: 'peugeot', model: 'peu-208', year: 2022, dailyRate: 95, color: 'Gray', plate: 'PEU-006' },
    { brand: 'peugeot', model: 'peu-2008', year: 2023, dailyRate: 105, color: 'White', plate: 'PEU-007' },
    { brand: 'fiat', model: 'fiat-tipo', year: 2022, dailyRate: 85, color: 'Orange', plate: 'FIA-008' },
    { brand: 'skoda', model: 'sk-octavia', year: 2023, dailyRate: 125, color: 'Black', plate: 'SKO-009' },
    { brand: 'seat', model: 'seat-leon', year: 2022, dailyRate: 115, color: 'Blue', plate: 'SEA-010' }
  ];

  return carConfigs.map((config, index) => ({
    id: `demo-car-${index + 1}`,
    brandId: config.brand,
    modelId: config.model,
    year: config.year,
    dailyRate: config.dailyRate,
    salePrice: config.dailyRate * 200, // Rough estimate
    purchasePrice: config.dailyRate * 150,
    supplierId: `supplier-${(index % 5) + 1}`, // Rotate through suppliers
    rating: 4.0 + Math.random() * 1.0, // 4.0 to 5.0
    transmission: Math.random() > 0.5 ? 'automatic' as const : 'manual' as const,
    fuel: 'gasoline' as const,
    plate: config.plate,
    color: config.color,
    mileageKm: Math.floor(Math.random() * 50000) + 10000,
    inGarage: true,
    isPaid: true,
    isRented: false,
    isForSale: false,
    isSold: false,
    images: [`https://images.unsplash.com/photo-${1555215695 + index}?w=400&h=300&fit=crop&crop=center`]
  }));
};

export const initialDb: DatabaseShape = {
  brands: initialBrands,
  models: initialModels,
  suppliers: initialSuppliers,
  cars: generateDemoCars(),
};
